var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FieldUpload',{attrs:{"fileIds":['5dcbf54868d64ffa8fc76ade847d4769','1b503507aa7649c297a07d844d8a9539']}}),_c('FieldUpload',{attrs:{"fileIds":['5dcbf54868d64ffa8fc76ade847d4769'],"type":"IMG"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }